import React from 'react';
import './_secondSlide.scss';
import '../../../styles/_landings.scss';

import Apple from '../../../assets/images/apple.svg';
import Android from '../../../assets/images/android.svg';
import image1 from '../../../assets/images/skillsharer/skillsharer-group1.jpg';
import image2 from '../../../assets/images/skillsharer/skillsharer-group2.jpg';
import image3 from '../../../assets/images/skillsharer/skillsharer-group3.jpg';
import image4 from '../../../assets/images/skillsharer/skillsharer-group4.jpg';

const SecondSlide = () => {
  return (
    <div className="skillsharer-second-slide">
      <div className="skillsharer-second-slide-images">
        <div className="skillsharer-second-slide-images-first">
          <img src={image1} alt="passsport" />
          <img src={image2} alt="passsport" />
        </div>
        <div className="skillsharer-second-slide-images-second">
          <img src={image3} alt="passsport" />
          <img src={image4} alt="passsport" />
        </div>
        <div className="skillsharer-second-slide-images-overlay" />
      </div>
      <div className="skillsharer-second-slide-subtitles">
        <div className="skill-store-button">
          <a href={window.location.hostname} title="Check Sporforya IOS app">
            <img src={Apple} alt="Apple" className="app-image" />
          </a>
          <a
            href={window.location.hostname}
            title="Check Sporforya Android app">
            <img src={Android} alt="Apple" className="app-image" />
          </a>
        </div>
        <div className="skillsharer-second-slide-subtitles-container">
          <h2>Connect with local pro&apos;s</h2>
          <h2>Schedule and book lessons</h2>
          <h2>Earn money teaching others</h2>
        </div>
      </div>
    </div>
  );
};

export default SecondSlide;
